import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import ManageProfile from './components/ManageProfile';
import { useDispatch, useSelector } from 'react-redux';
import { get_byID, get_paymentList } from './redux/slice';
// import { get_Payment_ID } from '../login/redux/slice';

const index = () => {
  useEffect(() => {
    document.title = 'View your profile - Edit & update information';
  }, []);

  const dispatch = useDispatch();

  const { user_data } = useSelector((state) => state.listDashboard);
  const { payment_data } = useSelector((state) => state.manageProfile);

  const profiles = user_data?.Profiles;
  console.log('user_data', user_data);

  useEffect(() => {
    get_listby_id();
    get_payment_list();
    // get_userPayment_id();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };

  // const get_userPayment_id = () => {
  //   dispatch(get_Payment_ID());
  // };

  const get_payment_list = () => {
    const payload = { page: 1 };
    dispatch(get_paymentList(payload));
  };

  return (
    <>
      <Layout sider={true}>
        <ManageProfile
          user_data={user_data}
          profiles={profiles}
          payment_data={payment_data}
        />
      </Layout>
    </>
  );
};

export default index;
